const images = [
  // '/images/common/arrow-back-enable.gif',
  // '/images/common/arrow-next-enable.gif',
  //'/images/history/en/btn-k4-1.png',
  // '/images/history/en/btn-k4-2.png',
  // '/images/history/en/btn-k5-1.png',
  // '/images/history/en/btn-k5-2.png',
  // '/images/history/en/btn-k5-3.png',
  // '/images/history/en/btn-k5-4.png',
  // '/images/history/en/btn-k5-5.png',
  // '/images/history/en/btn-k6-1.png',
  // '/images/history/en/btn-k6-2.png',
  // '/images/history/en/btn-k7-1.png',
  // '/images/history/en/btn-k8-1.png',
  // '/images/history/en/btn-k8-2.png',
  // '/images/history/en/btn-k8-3.png',
].map((src, index) => {
  new Image().src = src
}, this)

console.debug(`%c[script] preload images... ${images.length} files`, style.debug)
